// extracted by mini-css-extract-plugin
export default {"wrap":"DisableUserDialog-wrap","cancelButton":"DisableUserDialog-cancelButton","disableButton":"DisableUserDialog-disableButton","userCountText":"DisableUserDialog-userCountText"};